'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function plugin(Vue) {

	if (plugin.installed) {
		return;
	}
	var evmap = {};
	var events = new Vue({
		methods: {
			fire: function fire(name) {
				var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

				this.emit(name, data);
			},
			emit: function emit(name) {
				var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

				this.$emit(name, data);
			},
			listen: function listen(name, cb) {
				this.on(name, cb);
			},
			listenOnce: function listenOnce(name, cb) {
				this.once(name, cb);
			},
			on: function on(name, cb) {
				evmap[name] = cb;
				this.$on(name, cb);
			},
			once: function once(name, cb) {
				evmap[name] = cb;
				this.$once(name, cb);
			},
			off: function off(name, cb) {
				if (!cb) {
					cb = evmap[name];
				}
				this.$off(name, cb);
			},
			unlisten: function unlisten(name, cb) {
				this.off(name, cb);
			},
			removeAll: function removeAll() {
				this.$off();
			}
		}
	});

	Vue.mixin({
		beforeCreate: function beforeCreate() {
			if (_typeof(this.$options.eventBus) !== 'object') return;
			var eventMap = {};
			for (var key in this.$options.eventBus) {
				eventMap[key] = this.$options.eventBus[key].bind(this);
			}
			this.$once('hook:beforeMount', function () {
				for (var key in eventMap) {
					eventBus.$on(key, eventMap[key]);
				}
			});
			this.$once('hook:beforeDestroy', function () {
				for (var key in eventMap) {
					eventBus.$off(key, eventMap[key]);
				}
				eventMap = null;
			});
		}
	});

	Vue.events = events;

	Object.defineProperty(Vue.prototype, '$events', {
		get: function get() {
			return events;
		}
	});
}

if (typeof window !== 'undefined' && window.Vue) {
	window.Vue.use(plugin);
}

exports.default = plugin;


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-event-handler/dist/index.js
// module id = 1032
// module chunks = 0